import { ReactNode } from 'react';
import { Button } from '../../../../ui/components/ui/button';

export interface RowActionButtonProps {
  label: string;
  onClick: () => void;
  children: ReactNode;
}

/** Icon button inside a clickable table row – does not trigger the row click. */
const RowActionButton = ({ label, onClick, children }: RowActionButtonProps) => (
  <Button
    type="button"
    variant="ghost"
    size="sm"
    aria-label={label}
    title={label}
    className="h-8 w-8 p-0 text-[#12282A] hover:bg-[#F0F4FC] transition-colors duration-200"
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}>
    {children}
  </Button>
);

export default RowActionButton;
